import { useEffect, useRef } from "react";
import photo from "../assets/img/bannerbg2.jpg";
import { Reveal } from "./Reveal";

// Skill names drifting around the edges at different speeds (parallax).
const SKILLS = [
  { label: "React", side: "left", x: 5, top: 6, speed: 140 },
  { label: "Python", side: "right", x: 6, top: 9, speed: 220 },
  { label: "Next.js", side: "left", x: 13, top: 20, speed: 260 },
  { label: "Machine Learning", side: "right", x: 11, top: 24, speed: 150 },
  { label: "TypeScript", side: "left", x: 4, top: 36, speed: 190 },
  { label: "FastAPI", side: "right", x: 4, top: 41, speed: 250 },
  { label: "Node.js", side: "left", x: 12, top: 53, speed: 160 },
  { label: "Redux", side: "right", x: 13, top: 58, speed: 120 },
  { label: "Socket.IO", side: "left", x: 5, top: 70, speed: 230 },
  { label: "Tailwind", side: "right", x: 5, top: 74, speed: 180 },
  { label: "Angular", side: "left", x: 14, top: 86, speed: 130 },
  { label: "C++", side: "right", x: 12, top: 90, speed: 200 },
];

export const Intro = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    let frame = 0;
    const update = () => {
      frame = 0;
      const section = sectionRef.current;
      if (!section) return;
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight;
      // -1 as the section enters from below, 1 as it leaves at the top
      const progress = (vh / 2 - (rect.top + rect.height / 2)) / (rect.height / 2 + vh / 2);
      section.style.setProperty("--progress", Math.max(-1, Math.min(1, progress)).toFixed(4));
    };
    const requestUpdate = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("scroll", requestUpdate);
      window.removeEventListener("resize", requestUpdate);
    };
  }, []);

  return (
    <section className="intro" id="about" ref={sectionRef}>
      <div className="skill-cloud" aria-hidden="true">
        {SKILLS.map(({ label, side, x, top, speed }) => (
          <span key={label} style={{ [side]: `${x}%`, top: `${top}%`, "--speed": speed }}>{label}</span>
        ))}
      </div>
      <div className="intro-steps">
        <Reveal className="intro-step">
          <img className="intro-photo" src={photo} alt="Khushi Tulsiyan" />
          <p>Hello, I'm Khushi. I'm a software engineer who specializes in machine learning.</p>
        </Reveal>
        <Reveal className="intro-step">
          <p>I design intuitive interfaces and build machine learning into them, so the web experiences I make are efficient and genuinely useful.</p>
        </Reveal>
        <Reveal className="intro-step">
          <p>As a freelancer I keep things flexible and clear: I make sure I understand your vision, answer concerns promptly and send regular updates.</p>
        </Reveal>
      </div>
    </section>
  );
};
